/**
 * A SceneGraphNode
 *
 * @author Robert Wüest, Benjamin Loesch
 * @class SceneGraphNode
 * @param {Object} parentnode
 * @constructor
 * @param {SceneGraphNode} parentNode
 */
export class SceneGraphNode {
    constructor(parentNode) {
        /**
         * container for all behavior scripts
         * @property {Behavior[]} behaviors
         */
        this.behaviors = [];
        /**
         * container for 3d object
         * @default null
         */
        this.iMesh = null;
        /**
         * Container for camera object
         * @property {Object} iCamera
         * @default null
         */
        this.iCamera = null;
        this.initialized = false;
        /**
         * true if no z-coordinate given
         * @type {boolean} is2dfeature
         */
        this.is2dfeature = false;
        this.parentNode = parentNode;
    }
    init(traversalState) {
        this.currentTraversalState = traversalState;
        for (let i = 0; i < this.behaviors.length; i++) {
            this.behaviors[i].init(traversalState);
        }
        this.initialized = true;
    }
    render(traversalState) {
        this.currentTraversalState = traversalState;
        for (let i = 0; i < this.behaviors.length; i++) {
            this.behaviors[i].render(traversalState);
        }
    }
    exit(traversalState) {
        for (let i = 0; i < this.behaviors.length; i++) {
            this.behaviors[i].exit(traversalState);
        }
    }
    /**
     * Adds the bahvior to the behavior array
     * @method addBehavior
     * @param {Behavior} behavior
     */
    addBehavior(behavior) {
        behavior.parentObject = this;
        this.behaviors.push(behavior);
        // if already initialized, initialize the behaviour as well
        if (this.initialized) {
            behavior.init(this.currentTraversalState);
        }
    }
    removeBehavior() {
        alert("not implemented yet!");
    }
    highlight() {
        alert("not implemented yet!");
    }
    unhighlight() {
        alert("not implemented yet!");
    }
    destroy() {
        this.initialized = false;
    }
    update() {
        return;
    }
}
//# sourceMappingURL=scenegraphnode.js.map